var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-row',{attrs:{"wrap":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('grid-c',{attrs:{"gridConfig":_vm.grid,"title":"Daftar Diklat","add":"","search":"","id-key":"","filter":"","refresh":"","addText":"Diklat","items":_vm.items,"footerLabel":"Diklat","variablePencarian":[{ key: 'Nama', value: 'nama' }],"page":_vm.page,"footer":""},on:{"refresh":_vm.load,"filter":_vm.filter,"search":function (search) {
            _vm.dataPencarian = search;
            _vm.load();
          },"change:page":function (pg) {
            _vm.cp = pg;
            _vm.load();
          },"add":_vm.add},scopedSlots:_vm._u([{key:"items",fn:function(ref){
          var item = ref.item;
return [_c('v-divider')]}}])})],1),_c('ChangeDlg',{ref:"dlg"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }